import React, { useState } from "react";
import PropTypes from "prop-types";
import Modal from "react-bootstrap/Modal";

// import moment from "moment/min/moment-with-locales";
import moment from "moment";
import "moment/locale/th";
moment.locale("th");

import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";

//Import Loading
import LoadingAlert from "../../components/LoadingAlert";
import { toast } from "react-toastify";

// import TimeregService from "../../services/timereg.service";
import farmerMasterService from "../../services/farmermaster.service";
import academyService from "../../services/academy.service";

import { Form, Col, Row, FormControl } from "react-bootstrap";

import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

function ModaladdFarmermaster(props) {
  const [checkdata, setCheckdata] = useState([]);
  const [textSearch, setTextSearch] = useState("");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [disabledbutton, setDisabledbutton] = useState(true);

  const [assoc, setAssoc] = useState([]);

  const getMember = (farmer_idcard) => {
    academyService.getAcademyByPersonId(farmer_idcard).then((res) => {
      if (res.data.success && res.data.data.length > 0) {
        setAssoc(res.data.data);
      }
    });
  };

  const checkStatusMaster = (data) => {
    if (data.length != 0) {
      const result = data.filter((a) => {
        if (a.status === "เสียชีวิต" || a.status === "หน. กลุ่ม") {
          return true;
        } else if (
          (a.approve_status === "ฉบับร่าง" ||
            a.approve_status === "รออนุมัติ" ||
            a.approve_status === "ขอเอกสาร") &&
          a.timereg_id == props.timereg_id
        ) {
          return true;
        } else {
          return false;
        }
      });
      setDisabledbutton(result.length > 0 ? true : false);
    } else {
      setDisabledbutton(true);
    }
  };

  const searchChange = (value) => {
    setTextSearch(value);
    setDisabledbutton(true);
    if (value.length < 13) {
      setErrors({ ...errors, ["search"]: "กรอกเลขไม่ครบ" });
    } else if (value.length > 13) {
      setErrors({ ...errors, ["search"]: "กรอกเลขเกิน" });
    } else if (!checkID(value)) {
      setErrors({ ...errors, ["search"]: "เลขบัตรไม่ถูกต้อง" });
    } else {
      setErrors({ ...errors, ["search"]: null });
    }
  };
  const checkID = (id) => {
    if (id.length != 13) return false;
    let sum = 0;
    for (let i = 0; i < 12; i++) {
      sum += parseFloat(id.charAt(i)) * (13 - i);
    }
    if ((11 - (sum % 11)) % 10 != parseFloat(id.charAt(12))) return false;

    return true;
  };

  const findFormErrors = () => {
    const newErrors = {};

    // start date errors
    if (!textSearch || textSearch == "")
      newErrors.search = "กรุณากรอกเลขบัตรประชาชน";

    return newErrors;
  };

  const handleClose = () => {
    props.hidden(false);
    setTextSearch("");
    setDisabledbutton(true);
    setAssoc([]);
    setCheckdata([]);
  };

  const handleCheck = (e) => {
    e.preventDefault();

    const newErrors = findFormErrors();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
    } else {
      setLoading(true);
      getMember(textSearch);
      farmerMasterService
        .checkFarmerMaster({ search: textSearch })
        .then((response) => {
          if (response.data.success && response.data.data.length != 0) {
            checkStatusMaster(response.data.data);
            setCheckdata(response.data.data);
          } else {
            confirmAlert({
              title: "",
              message: "เลขบัตร " + textSearch + " ไม่ได้เป็นชาวไร่อ้อย",
              buttons: [
                {
                  label: "ปิด",
                  onClick: () => {},
                },
                // {
                //   label: "ไม่ใช่",
                //   onClick: () => false,
                // },
              ],
              overlayClassName: "confirm-alert-default",
            });
          }
        })
        .catch((err) => {
          toast.error(err);
        })
        .finally(() => setLoading(false));
    }
  };

  const clickAddMaster = (e) => {
    e.preventDefault();
    setCheckdata([]);
    const newTextSearch = textSearch;
    props.onClickAdd(
      newTextSearch,
      Object.keys(checkdata).length > 0 ? checkdata[0].regsugar_id : null
    );
    setTextSearch("");
    setDisabledbutton(true);
  };

  const columns = [
    {
      dataField: "timereg_id",
      text: "timereg_id",
      hidden: true,
    },
    {
      dataField: "farmer_name",
      text: "ชื่อ",
      headerStyle: () => {
        return { textAlign: "center", width: "17%" };
      },
      style: {
        wordBreak: "break-word",
        textAlign: "center",
      },
    },
    {
      dataField: "farmer_lastname",
      text: "นามสกุล",
      headerStyle: () => {
        return { textAlign: "center", width: "17%" };
      },
      style: {
        wordBreak: "break-word",
        textAlign: "center",
      },
    },
    {
      dataField: "status",
      text: "หน.กลุ่ม",
      // formatter: statusFormatter,
      headerStyle: () => {
        return { textAlign: "center", width: "15%" };
      },
      style: {
        wordBreak: "break-word",
        textAlign: "center",
      },
    },
    {
      dataField: "timereg_desc",
      text: "รอบจดทะเบียน",
      headerStyle: () => {
        return { textAlign: "center", width: "10%" };
      },
      style: {
        wordBreak: "break-word",
        textAlign: "center",
      },
    },
    {
      dataField: "approve_status",
      text: "ผลการพิจารณา",
      headerStyle: () => {
        return { textAlign: "center", width: "10%" };
      },
      style: {
        wordBreak: "break-word",
        textAlign: "center",
      },
    },
    {
      dataField: "farmer_card",
      text: "เลขหัวหน้ากลุ่ม",
      headerStyle: () => {
        return { textAlign: "center", width: "12%" };
      },
      style: {
        wordBreak: "break-word",
        textAlign: "center",
      },
    },
    {
      dataField: "start_date",
      text: "เริ่ม",
      formatter: (cell) => {
        if (cell != "-") {
          return moment(new Date(cell))
            .add(543, "year")
            .locale("th")
            .format("ll");
        } else {
          return cell;
        }
      },
      filterValue: (cell) => {
        if (cell != "-") {
          return moment(new Date(cell))
            .add(543, "year")
            .locale("th")
            .format("ll");
        } else {
          return cell;
        }
      },
      headerStyle: () => {
        return { textAlign: "center", width: "10%" };
      },
      style: {
        wordBreak: "break-word",
        textAlign: "center",
      },
    },
    {
      dataField: "end_date",
      text: "สิ้นสุด",
      formatter: (cell) => {
        if (cell != "-") {
          return moment(new Date(cell))
            .add(543, "year")
            .locale("th")
            .format("ll");
        } else {
          return cell;
        }
      },
      filterValue: (cell) => {
        if (cell != "-") {
          return moment(new Date(cell))
            .add(543, "year")
            .locale("th")
            .format("ll");
        } else {
          return cell;
        }
      },
      headerStyle: () => {
        return { textAlign: "center", width: "10%" };
      },
      style: {
        wordBreak: "break-word",
        textAlign: "center",
      },
    },
  ];

  return (
    <>
      {loading ? <LoadingAlert /> : ""}
      <Modal size="xl" show={props.show} onHide={handleClose} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>จดทะเบียนหัวหน้ากลุ่ม</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="search-check">
            <Form>
              <Row className="search-check">
                <Col lg="5">
                  <Form.Group>
                    <FormControl
                      placeholder="กรอกบัตรประชาชน"
                      type="number"
                      name="search"
                      value={textSearch}
                      onChange={(e) => searchChange(e.target.value)}
                      isInvalid={!!errors.search}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.search}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col lg="4">
                  <Form.Group>
                    <button
                      className="btn btn-primary btn-add-custom"
                      onClick={handleCheck}
                    >
                      ค้นหาและตรวจสอบ
                    </button>
                  </Form.Group>
                </Col>
                <Col lg="3" style={{ textAlign: "end" }}>
                  <Form.Group>
                    <button
                      disabled={disabledbutton}
                      className="btn btn-success btn-disable-custom"
                      onClick={clickAddMaster}
                    >
                      จดทะเบียน
                    </button>
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          </div>
          <div className="list-regsugar-name">
            <BootstrapTable
              keyField="timereg_id"
              data={checkdata}
              columns={columns}
            />
          </div>
          {assoc.map((item, key) => {
            return (
              <div key={key}>
                <li className="cademy-ui" key={key} name={item.association_id}>
                  {item.association_name_th}
                </li>
              </div>
            );
          })}
        </Modal.Body>
      </Modal>
    </>
  );
}

export default ModaladdFarmermaster;

ModaladdFarmermaster.propTypes = {
  show: PropTypes.bool,
  hidden: PropTypes.func,
  onClickAdd: PropTypes.func,
  timereg_id: PropTypes.number,
  // setdata: PropTypes.func,
};
